import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ROUTES } from "@/constants/routes";

export function SettingsSubHeader({ leagueId, title }: { leagueId: string; title: string }) {
  const navigate = useNavigate();
  return (
    <div className="mb-3 flex items-center gap-2">
      <button
        onClick={() => navigate(ROUTES.leagueSettings(leagueId))}
        aria-label="Voltar às configurações"
        className="flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted"
      >
        <ArrowLeft className="h-4 w-4" />
      </button>
      <h1 className="font-display text-base font-bold">{title}</h1>
    </div>
  );
}
